import {
  CalendarIcon,
  PencilSquareIcon,
  LockOpenIcon,
  UserGroupIcon
} from "@heroicons/react/24/outline"
import { ButtonLink } from "components/ui"

export const TutorialPage = () => {
  const steps = [
    {
      id: 1,
      title: "Create your Time Capsule",
      description:
        "Start by creating a new time capsule. Give it a meaningful name and set a future date when it will be opened. This date will lock all entries until then.",
      icon: CalendarIcon
    },
    {
      id: 2,
      title: "Add your Memories",
      description:
        "Write your thoughts, memories, and messages that you want to preserve. Each text entry will be safely stored and locked until the opening date.",
      icon: PencilSquareIcon
    },
    {
      id: 3,
      title: "Open on the Special Day",
      description:
        "When the opening date arrives, your time capsule will unlock automatically. Rediscover all the memories you've preserved.",
      icon: LockOpenIcon
    },
    {
      id: 4,
      title: "Share with Others",
      description:
        "Optionally invite friends or family to contribute. Create shared memories together that you can all enjoy when the capsule opens.",
      icon: UserGroupIcon
    }
  ]

  return (
    <div className="bg-white dark:bg-gray-900 px-6 lg:px-8">
      <div className="mx-auto max-w-2xl text-center">
        <h2 className="text-4xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-6xl">
          How It Works
        </h2>
        <p className="mt-6 text-lg leading-8 text-gray-600 dark:text-gray-300">
          Create, preserve, and rediscover your memories with digital time capsules
        </p>
      </div>

      <div className="mx-auto mt-16 max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:text-center">
          <p className="mt-2 text-3xl font-bold tracking-tight text-gray-900 dark:text-white sm:text-4xl">
            Simple steps to preserve your memories
          </p>
        </div>

        <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:mt-24 lg:max-w-none">
          <dl className="grid max-w-xl grid-cols-1 gap-x-8 gap-y-16 lg:max-w-none lg:grid-cols-2">
            {steps.map((step) => (
              <div key={step.id} className="flex flex-col">
                <dt className="flex items-center gap-x-3 text-base font-semibold leading-7 text-gray-900 dark:text-white">
                  <div className="rounded-lg bg-primary-100 p-2">
                    <step.icon className="h-6 w-6 text-primary-600" aria-hidden="true" />
                  </div>
                  {step.title}
                </dt>
                <dd className="mt-4 flex flex-auto flex-col text-base leading-7 text-gray-600 dark:text-gray-300">
                  <p className="flex-auto">{step.description}</p>
                </dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="mt-16 flex justify-center">
          <ButtonLink to="/new/time-capsule" size="lg">
            Create A New Time Capsule
          </ButtonLink>
        </div>
      </div>
    </div>
  )
}
